import { fromJS } from 'immutable';
import {
  DELETE_TIMER_SUCCESS,
  INIT_TIMER_SUCCESS,
  LOAD_USER_LAST_TASK_SUCCESS,
  SET_TIMER_STARTED_SOCKET,
  SET_TIMER_STOPPED_SOCKET,
  START_TIMER_SUCCESS,
  STOP_TIMER,
  STOP_TIMER_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  count: 0,
  startTime: 0,
  status: null,
  title: null,
  timeId: null,
  taskId: null,
});

const timerReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_USER_LAST_TASK_SUCCESS: {
      if (action.stats?.currentTimer) {
        const timer = action.stats?.currentTimer;
        return state.merge(
          fromJS({
            ...timer,
            title: timer.task?.header,
            taskId: timer.task?.taskId,
            projectId: timer.task?.projectId,
          }),
        );
      }
      return state;
    }
    case INIT_TIMER_SUCCESS:
    case SET_TIMER_STARTED_SOCKET:
    case SET_TIMER_STOPPED_SOCKET:
    case START_TIMER_SUCCESS:
      if (action.values) {
        return state.merge(
          fromJS({
            timeId: action.values.timeId,
            status: action.values.status,
            taskId: action.values.taskId,
            taskTitle: action.values.taskTitle,
            startTime: parseInt(action.values.startTime),
            count: action.values.todayCount ? action.values.todayCount : 0,
            title: action.values.title,
            projectId: action.values.projectId,
          }),
        );
      }
      return state;
    case STOP_TIMER:
      return state.set('status', 'stopped');
    case STOP_TIMER_SUCCESS:
      return state.set('count', action.values.todayCount);
    case DELETE_TIMER_SUCCESS:
      return initialState;
    default:
      return state;
  }
};

export default timerReducer;
